import {
  COMPONENT_CLASS,
  COMPONENT_NAME,
  EVENT,
  SELECTED_OPTION,
} from '@jusbrasil-web/shared-ga4-events'

export const COMPONENT_RENDER_EVENT_PROPS = {
  VALIDATE_IDENTITY: [
    {
      item_variant: SELECTED_OPTION.VALIDATE_IDENTITY,
      item_brand: null,
      item_name: COMPONENT_NAME.IDENTITY_VALIDATION,
      item_id: null,
    },
  ],
  VALIDATE_IDENTITY_DOCUMENT_CPF_VALIDATION_FORM_ATTACHMENT: [
    {
      item_variant: null,
      item_brand: COMPONENT_CLASS.CPF_VALIDATION_FORM_ATTACHMENT_ACCESS,
      item_name: COMPONENT_NAME.DOCUMENT_VALIDATION,
      item_id: null,
    },
  ],
  VALIDATE_IDENTITY_DOCUMENT_ERROR_CPF_VALIDATION_FORM_ATTACHMENT: [
    {
      item_variant: SELECTED_OPTION.REVIEW_INFORMATION,
      item_brand: COMPONENT_CLASS.CPF_VALIDATION_FORM_ATTACHMENT_ACCESS,
      item_name: COMPONENT_NAME.IDENTITY_VERIFICATION_FAIL,
      item_id: null,
    },
  ],
  CPF_IN_USE: [
    {
      item_variant: SELECTED_OPTION.REVIEW_INFORMATION,
      item_brand: null,
      item_name: COMPONENT_NAME.IDENTITY_ALREADY_VERIFIED,
      item_id: null,
    },
    {
      item_variant: SELECTED_OPTION.CURRENT_ACCOUNT_REGISTER,
      item_brand: null,
      item_name: COMPONENT_NAME.IDENTITY_ALREADY_VERIFIED,
      item_id: null,
    },
  ],
  IDENTITY_ERROR: [
    {
      item_variant: SELECTED_OPTION.CONTINUE_BUTTON,
      item_brand: null,
      item_name: COMPONENT_NAME.IDENTITY_VERIFICATION_FAIL,
      item_id: null,
    },
  ],
  IDENTITY_SUCCESS: [
    {
      item_variant: SELECTED_OPTION.CONTINUE_BUTTON,
      item_brand: null,
      item_name: COMPONENT_NAME.IDENTITY_VERIFIED,
      item_id: null,
    },
  ],
  REMOVAL_CPF_EMAIL: [
    {
      item_variant: SELECTED_OPTION.COMPLETE,
      item_brand: null,
      item_name: COMPONENT_NAME.VERIFICATION_EMAIL_SENT,
      item_id: null,
    },
    {
      item_variant: SELECTED_OPTION.CONTACT_SUPPORT,
      item_brand: null,
      item_name: COMPONENT_NAME.VERIFICATION_EMAIL_SENT,
      item_id: null,
    },
  ],
  STUDENT_ENROLLMENT_ACADEMIC_DATA: [
    {
      item_variant: SELECTED_OPTION.CONTINUE_BUTTON,
      item_brand: null,
      item_name: COMPONENT_NAME.IDENTITY_VALIDATION,
      item_id: null,
    },
  ],
  STUDENT_ENROLLMENT_UPLOAD_INSTRUCTIONS: [
    {
      item_variant: null,
      item_brand: null,
      item_name: COMPONENT_NAME.DOCUMENT_VALIDATION,
      item_id: null,
    },
  ],
  STUDENT_ENROLLMENT_ERROR: [
    {
      item_variant: SELECTED_OPTION.REVIEW_INFORMATION,
      item_brand: null,
      item_name: COMPONENT_NAME.IDENTITY_VERIFICATION_FAIL,
      item_id: null,
    },
  ],
  STUDENT_ENROLLMENT_SUCCESS: [
    {
      item_variant: SELECTED_OPTION.CONTINUE_BUTTON,
      item_brand: null,
      item_name: COMPONENT_NAME.IDENTITY_VERIFIED,
      item_id: null,
    },
  ],
}

export const CLICK_EVENT_PROPS = {
  CPF_IN_USE: {
    componentClass: null,
    componentName: COMPONENT_NAME.IDENTITY_ALREADY_VERIFIED,
    selectedOption: '',
    resourceId: null,
  },
  IDENTITY_ERROR: {
    componentClass: null,
    componentName: COMPONENT_NAME.IDENTITY_VERIFICATION_FAIL,
    selectedOption: SELECTED_OPTION.CONTACT_SUPPORT,
    resourceId: null,
  },
  REMOVAL_CPF_EMAIL: {
    componentClass: null,
    componentName: COMPONENT_NAME.VERIFICATION_EMAIL_SENT,
    selectedOption: '',
    resourceId: null,
  },
}

export const INPUT_START_EVENT_PROPS = {
  VALIDATION_IDENTITY_FORM: {
    componentClass: null,
    componentName: COMPONENT_NAME.IDENTITY_VALIDATION,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.TEXT_TYPE,
  },
  VALIDATE_IDENTITY_DOCUMENT_FILE_UPLOAD_CPF_VALIDATION_FORM_ATTACHMENT: {
    componentClass: COMPONENT_CLASS.CPF_VALIDATION_FORM_ATTACHMENT_ACCESS,
    componentName: COMPONENT_NAME.DOCUMENT_VALIDATION,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.FILE_UPLOAD,
  },
}

export const INPUT_SUBMIT_EVENT_COMPONENT_PROPS = {
  VALIDATING_IDENTITY_FALSE: {
    componentClass: null,
    componentName: COMPONENT_NAME.IDENTITY_VALIDATION,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.TEXT_TYPE,
    successfulAttempt: false,
  },
  VALIDATING_IDENTITY_TRUE: {
    componentClass: null,
    componentName: COMPONENT_NAME.IDENTITY_VALIDATION,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.TEXT_TYPE,
    successfulAttempt: true,
  },
  VALIDATE_IDENTITY_DOCUMENT_FILE_UPLOAD_CPF_VALIDATION_FORM_ATTACHMENT: {
    componentClass: COMPONENT_CLASS.CPF_VALIDATION_FORM_ATTACHMENT_ACCESS,
    componentName: COMPONENT_NAME.DOCUMENT_VALIDATION,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.FILE_UPLOAD,
    successfulAttempt: false,
  },
  STUDENT_ENROLLMENT_DOCUMENT_SUBMIT: {
    componentClass: null,
    componentName: COMPONENT_NAME.DOCUMENT_VALIDATION,
    featureClass: null,
    featureName: null,
    inputMethod: EVENT.FILE_UPLOAD,
    successfulAttempt: false,
  },
}
